import React, { useState } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "../Input/dropDownInput/dropDownInput";

const LobFilter = ({
  showFilter,
  applyFilter,
  setSelectedFilterLob,
  setSelectedLobCode,
  setSelectedDimension,
}) => {

  const dimensionValueTypeOptions = [
    { id: "Begin-Total", name: "Begin-Total" },
    { id: "Standard", name: "Standard" },
    { id: "End-Total", name: "End-Total" },
  ];

  const storageKey = "lob_filter";

  const savedFilter = JSON.parse(window.localStorage.getItem(storageKey) || "{}");

  const [filterFieldsData, setFilterFieldsData] = useState({
    name: savedFilter?.name || "",
    erp_code: savedFilter?.erp_code || "",
    dimension_value_type: savedFilter?.dimension_value_type || "",
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem(storageKey, JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label="LOB"
        type="text"
        isStarRequired={false}
        value={filterFieldsData.name}
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            name: val,
          });
          setSelectedFilterLob(val);
        }}
      />

      <DropDownInput
        label='Dimension Value Type'
        data={dimensionValueTypeOptions}
        getValueById={filterFieldsData?.dimension_value_type}
        getIdValue={(val) => {
        setFilterFieldsData({ 
            ...filterFieldsData, 
            dimension_value_type: val.id 
        });
        setSelectedDimension(val.id);
        }}
      />

      <ConstantInput
        label="Code"
        type="text"
        isStarRequired={false}
        value={filterFieldsData.erp_code}
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            erp_code: val,
          });
          setSelectedLobCode(val);
        }}
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>

        <br />
        <br />

        <button
          onClick={() => {
            setSelectedFilterLob("");
            setSelectedLobCode("");
            setSelectedDimension("");
            window.localStorage.removeItem(storageKey);
            window.location.reload();
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default LobFilter;